import type { FC, ReactNode } from 'react'

import { Logo } from '@/components/landing/site-header'
import { NAV_LINKS } from '@/constants/site'

const SiteFooter: FC = (): ReactNode => (
    <footer className='border-t border-white/10'>
        <div className='mx-auto flex max-w-6xl flex-col gap-8 px-6 py-12 md:flex-row md:justify-between'>
            <div>
                <Logo />
                <p className='mt-3 text-sm text-slate-500'>Useful tools for the task in front of you.</p>
            </div>
            <ul className='flex flex-wrap gap-x-6 gap-y-3 text-sm text-slate-400'>
                {[...NAV_LINKS, { label: 'Privacy', href: '/privacy' }, { label: 'Terms', href: '/terms' }].map((link) => (
                    <li key={link.label}><a href={link.href} className='hover:text-cyan-300'>{link.label}</a></li>
                ))}
            </ul>
        </div>
        <p className='mx-auto max-w-6xl px-6 pb-10 text-xs text-slate-600'>© 2026 Rare Frequency Works</p>
    </footer>
)

export default SiteFooter
